<template>
  <div class="features-point">
    <div class="ponit_title">
      <p class="ponit_title-top">纸箱厂管理痛点</p>
      <p class="ponit_title-desc">
        外部市场无序竞争 内部生产与成本管理失衡<br />
        企业陷入“越忙越亏”困境
      </p>
    </div>
    <div class="point_card">
      <div class="point_card-item">
        <div class="point_card-item-title">外部市场</div>
        <p>商业模式同质化，陷入“低质量竞争”恶性循环</p>
        <p>管理体系落后，无法适应现代用工与客户需求</p>
        <p>盈利模式单一，抗风险能力脆弱</p>
      </div>
      <div class="point_card-item sec-item">
        <div class="point_card-item-title">工厂内部</div>
        <p>生产与销售协同失效，缺乏精细化成本管理</p>
        <p>流程标准化缺失，作业规范执行不力</p>
        <p>业财数据割裂，信息流通全靠人工</p>
      </div>
    </div>
    <div class="ponit_title">
      <p class="ponit_title-top">纸箱厂管理方案</p>
      <p class="ponit_title-desc">
        让纸箱厂老板省心一点、多赚一点<br />提高纸箱厂持续发展的能力
      </p>
    </div>
    <div class="ponit_video">
      <video-player
        class="video-player vjs-custom-skin vjs-big-play-centered"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      />
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  name: 'painPoint',
  components: { videoPlayer },
  data() {
    return {
      styleObject: {},
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: window.innerWidth > 960, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [
          {
            src: require('@/assets/images/video.mp4'),
            type: 'video/mp4' // 类型
          }
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
          volumePanel: { inline: false }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.features-point {
  width: 100%;
  min-height: 80vh; /* 使用最小高度而不是固定高度 */
  background: linear-gradient(180deg, #000000 0%, #353535 100%);
  color: #ffffff;
  padding-bottom: 40px; /* 添加底部内边距 */
  box-sizing: border-box; /* 确保内边距不会增加总宽度 */

  .ponit_title {
    text-align: center;
    padding: 0 20px; /* 添加水平内边距防止内容贴边 */

    &-top {
      padding-top: 32px;
      font-family: AlibabaPuHuiTi_2_65_Medium;
      font-size: 32px;
      color: #ffffff;
      margin-bottom: 16px; /* 使用margin替代padding控制间距 */
    }

    &-desc {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 24px;
      color: #ffffff;
      max-width: 800px;
      margin: 0 auto; /* 居中 */
    }
  }
  .point_card {
    margin: 0px 28px 0 32px;

    &-item {
      min-height: 314px; /* 使用最小高度而不是固定高度 */
      margin-top: 32px;
      box-shadow: 0px 0 15px 0px rgba(0, 0, 0, 0.07);
      border-radius: 16px;
      background-image: url('../../../assets/images/productFeatures/bg_market.png');
      background-position: center;
      background-size: cover;
      padding: 16px 14px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      // justify-content: center;

      &-title {
        margin-bottom: 4px;
        font-family: AlibabaPuHuiTi_2_65_Medium;
        font-size: 32px;
      }
      p {
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-size: 24px;
        margin-top: 12px;
      }
    }
    .sec-item {
      text-align: right;
      background-image: url('../../../assets/images/productFeatures/bg_factory.png');
    }
  }
  .ponit_video {
    margin: 32px 20px 0; /* 调整边距 */
    overflow: hidden;
    position: relative;

    .video-container {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%; /* 16:9 宽高比 */

      .video-player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

/* 平板设备 */
@media (min-width: 750px) and (max-width: 960px) {
  .features-point {
    /* 移除固定高度，让内容自然撑开 */

    .ponit_title {
      &-top {
        font-size: 44px; /* 适当调整字体大小 */
      }

      &-desc {
        font-size: 36px;
        max-width: 800px;
      }
    }

    .point_card {
      margin: 60px 40px 0; /* 增加边距 */
      display: flex;
      justify-content: space-between;
      align-items: stretch; /* 让卡片等高 */
      gap: 32px; /* 调整间距 */

      &-item {
        flex: 1;
        margin-top: 0; /* 移除上边距，因为使用gap控制间距 */
        min-height: 500px; /* 增加最小高度 */

        &-title {
          font-size: 36px;
        }

        p {
          font-size: 22px;
        }
      }
    }

    .ponit_video {
      margin: 80px 40px 0;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

/* 桌面设备 */
@media (min-width: 961px) {
  .features-point {
    /* 移除固定高度，让内容自然撑开 */

    .ponit_title {
      &-top {
        padding-top: 48px;
        font-size: 48px;
      }

      &-desc {
        font-size: 38px;
        max-width: 800px;
      }
    }

    .point_card {
      margin: 60px 60px 0;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      gap: 48px;

      &-item {
        flex: 1;
        margin-top: 0;
        min-height: 550px;
        padding: 40px 32px;

        &-title {
          font-size: 40px;
        }

        p {
          font-size: 24px;
        }
      }
    }

    .ponit_video {
      margin: 80px auto 0;
      max-width: 1200px;
      width: calc(100% - 120px); /* 使用计算宽度确保有足够的边距 */
    }
  }
}

/* 超大屏幕优化 */
@media (min-width: 1200px) {
  .features-point {
    .point_card {
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
